import { render, staticRenderFns } from "./bankItem.vue?vue&type=template&id=4e84ab0a&"
import script from "./bankItem.vue?vue&type=script&lang=js&"
export * from "./bankItem.vue?vue&type=script&lang=js&"
import style0 from "./bankItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports